export const data = [
    {
        NAME: 'Home Keepr',
        LOGO: '',
        DESCRIPTION: 'MooveGuru is a service that helps people who are moving to a new home find and compare moving companies, storage facilities, and other related services.',
        TEAM: 12,
        ROLE: 'Frontend Developer',
        LINK: 'https://www.mooveguru.com/'
    },
    {
        NAME: 'Sundance Film Festival',
        LOGO: '',
        DESCRIPTION: 'The Sundance Film Festival is the ultimate gathering of original storytellers and audiences seeking new voices and fresh perspectives.',
        TEAM: 30,
        ROLE: 'Frontend Developer',
        LINK: 'https://festival.sundance.org/'
    },
    {
        NAME: 'Baseball Cloud',
        LOGO: '',
        DESCRIPTION: 'BaseballCloud is a community focused on enhancing amateur baseball through the use of data.',
        TEAM: 10,
        ROLE: 'Frontend Developer',
        LINK: 'https://www.baseballcloud.com/'
    },
    {
        NAME: 'VeDA',
        LOGO: '',
        DESCRIPTION: 'The Vestibular Disorders Association (VeDA) strives to create an inclusive community where everyone feels valued, represented, and respected. Platform provides one to one support via video meet.',
        TEAM: 4,
        ROLE: 'Frontend Developer',
        LINK: 'https://www.coralive.org/en/'
    },
    {
        NAME: 'Kaizer',
        LOGO: '',
        DESCRIPTION: 'It\'s an internal software for the company that manages all the departments in one system.',
        TEAM: 4,
        ROLE: 'Frontend Developer',
        LINK: ''
    },
    {
        NAME: 'Cora',
        LOGO: '',
        DESCRIPTION: 'Coralive is a environmental organization, passionate for the ocean, operating worldwide to help protect, manage and restore coastal ecosystems. As in nature, diversity and synergies are key in creating a healthy environment, hence our team represents diverse backgrounds of experience and expertise to provide the multi-faceted services we offer.',
        TEAM: 2,
        ROLE: 'Frontend Developer',
        LINK: 'https://www.coralive.org/en/'
    },
    {
        NAME: 'MySail',
        LOGO: '',
        DESCRIPTION: 'Sailer can make his team and participate in different sailing events and also represent any clubs & associations. Also the owner can find new crew members and manage the team.',
        TEAM: 2,
        ROLE: 'Frontend Developer',
        LINK: 'https://app.mysail.team/'
    },
    {
        NAME: 'Unistel',
        LOGO: '',
        DESCRIPTION: 'Unistel offers a complete genetic testing service to physicians, patients and clients. All staff members are dedicated to providing the highest quality medical and animal genetic services possible. It is an internal system that manages all the genetic testing and also connected with multiple devices and system algorithms also helps for results and analysis.',
        TEAM: 2,
        ROLE: 'Full-stack Developer',
        LINK: 'https://unistelstaging.azurewebsites.net/login'
    },
    {
        NAME: 'Patient Studio',
        LOGO: '',
        DESCRIPTION: 'A Patientstudio site is a web-based platform that allows patients to schedule appointments, view medical records, and communicate with their healthcare providers. It also allows doctors to manage their patient schedules, view patient information, and electronically prescribe medications.',
        TEAM: 2,
        ROLE: 'Full-stack Developer',
        LINK: 'https://app.patientstudio.com/'
    },
    {
        NAME: 'FrenchiZer',
        LOGO: '',
        DESCRIPTION: 'It\'s franchise base application where user can take, sell & manage his frenchie.',
        TEAM: 2,
        ROLE: 'Frontend Developer',
        LINK: '#'
    },
    {
        NAME: 'QuoteFlare',
        LOGO: '',
        DESCRIPTION: 'Quoteflare gives his customers easier access to their services. You can provide as many quotes and bookings as you want. There is no limit. You can install each Quote Center in as many places as you want, on as many pages as you want. You can even install it on your facebook. Not only can customers get instant quotes, but can also offer phone and field quotes too.',
        TEAM: 1,
        ROLE: 'Frontend Developer',
        LINK: 'https://www.quoteflare.com/'
    },
    {
        NAME: 'iVerity',
        LOGO: '',
        DESCRIPTION: 'This site is a web-based platform that is designed to assist with the management of criminal cases and offenders. iVerity can be used by law enforcement agencies, courts, probation departments, and other criminal justice organizations to track and manage information related to criminal cases, defendants, and offenders. ',
        TEAM: 2,
        ROLE: 'Full-stack Developer',
        LINK: 'https://www.iverity.co.za/'
    },

];